<template>
    <div id="csContainer"></div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
import util from "../../components/util"
export default {
    data() {
        return {
            viewer: null,
            positionArr: [],
            ab:null
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        // positionArr: function (val) {
        //     if (this.ab !== null){
        //         var uu = Cesium.Cartesian3.fromDegreesArrayHeights(val);
        //
        //         this.ab.wall.material = Cesium.Color.RED
        //     }
        //
        //     // this.viewer.entities.removeById('ab');
        //     // debugger
        //     // this.viewer.entities.add({
        //     //
        //     //     // id: 'ab',
        //     //     wall: {
        //     //         positions: uu,
        //     //         material: Cesium.Color.AQUAMARINE.withAlpha(0.5)
        //     //     }
        //     // });
        //     // this.viewer.zoomTo(this.viewer.entities);
        // }
    },
    methods: {
        computeCirclularFlight(x1, y1, x2, y2, fx, angle) {
            let positionArr = [];
            positionArr.push(x1);
            positionArr.push(y1);
            positionArr.push(0);

            var radius = Cesium.Cartesian3.distance(Cesium.Cartesian3.fromDegrees(x1, y1), Cesium.Cartesian3.fromDegrees(x2, y2));

            for (let i = fx; i <= fx + angle; i++) {
                let h = radius * Math.sin(i * Math.PI / 180.0);
                let r = Math.cos(i * Math.PI / 180.0);

                let x = (x2 - x1) * r + x1;
                let y = (y2 - y1) * r + y1;

                positionArr.push(x);
                positionArr.push(y);
                positionArr.push(h);
            }
            return positionArr;
        },
        calcPoints(x1, y1, radius, heading) {

            var m = Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(x1, y1));

            var rx = radius * Math.cos(heading * Math.PI / 180.0);
            var ry = radius * Math.sin(heading * Math.PI / 180.0);

            var translation = Cesium.Cartesian3.fromElements(rx, ry, 0);

            var d = Cesium.Matrix4.multiplyByPoint(m, translation, new Cesium.Cartesian3());

            var c = Cesium.Cartographic.fromCartesian(d);

            var x2 = Cesium.Math.toDegrees(c.longitude);
            var y2 = Cesium.Math.toDegrees(c.latitude);
            return this.computeCirclularFlight(x1, y1, x2, y2, 0, 90);
        },
        init() {
            this.viewer = util.getViewer('csContainer', {
                shouldAnimate: true,
                infoBox: true,
                selectionIndicator: true,
            });
            this.viewer.scene.globe.depthTestAgainstTerrain = true;
            var heading = 0;
            this.positionArr = this.calcPoints(114, 30, 100, heading);
            let ab22 = this.calcPoints(114, 30, 100, heading);;
            let positionArr = this.positionArr;

            function hh() {

                let ab = [];
                let mm = Cesium.Cartesian3.fromDegreesArrayHeights(positionArr);
                for (let i = 0; i < mm.length; i++) {
                    ab.push(mm[i].x);
                    ab.push(mm[i].y);
                    ab.push(mm[i].z);
                }

                return Cesium.Cartesian3.fromDegreesArrayHeights();
            }
            // let self = this;
            function aa() {
                let ab = self.positionArr;
                let uu = Cesium.Cartesian3.fromDegreesArrayHeights(self.positionArr);
                debugger
                return uu;
            }
            function bb (){
                return Cesium.Cartesian3.fromDegreesArrayHeights(positionArr)
            }
            var uu = Cesium.Cartesian3.fromDegreesArrayHeights(ab22);
            this.ab = this.viewer.entities.add({

                // id: 'ab',
                id: 'ab',
                wall: {
                    positions: new Cesium.CallbackProperty(bb, false),
                    material: Cesium.Color.AQUAMARINE.withAlpha(0.5)
                }
            });
            // this.ab.wall.material =   Cesium.Color.RED;

            let ab2222 = this.viewer.entities.add({
                position: Cesium.Cartesian3.fromDegrees(114, 30),
                ellipsoid: {
                    radii: new Cesium.Cartesian3(100, 100, 100),
                    maximumCone: Cesium.Math.toRadians(90),
                    material: Cesium.Color.AQUAMARINE.withAlpha(0.3),
                    outline: true,
                    outlineColor: Cesium.Color.AQUAMARINE.withAlpha(0.5),
                    outlineWidth: 1
                }
            });
            this.viewer.zoomTo(this.viewer.entities);
            // ab2222.ellipsoid.material =   Cesium.Color.RED;


            //执行动画效果
            this.viewer.clock.onTick.addEventListener(() => {
                heading += 0.1;
                this.positionArr = this.calcPoints(114, 30, 100, heading);
            });
        },
    }
}

</script>
<style scoped>
#csContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
